import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-exit",
  "use": "icon-exit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-exit\"><defs><style type=\"text/css\"></style></defs><path d=\"M768 640l0-128-320 0 0-128 320 0 0-128 192 192zM704 576l0 256-320 0 0 192-384-192 0-832 704 0 0 320-64 0 0-256-512 0 256 128 0 576 256 0 0-192z\" p-id=\"7801\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol